import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Summary } from './groupRulesSummary.styles';
import messages from './groupRulesSummary.messages';
import { renderWhenNotNil, renderWhenTrue } from '../../../../../shared/utils/rendering';

export class GroupRulesSummary extends PureComponent {
  static propTypes = {
    experience: PropTypes.object,
    isGroupExperience: PropTypes.bool,
  };

  renderGroupSizeInfo() {
    const { minGroupSize, maxGroupSize } = this.props.experience;
    let messageId = null;
    if (minGroupSize && maxGroupSize) {
      messageId = minGroupSize === maxGroupSize ? 'groupInfoExact' : 'groupInfoMinMax';
    } else if (minGroupSize) {
      messageId = 'groupInfoMin';
    } else if (maxGroupSize) {
      messageId = 'groupInfoMax';
    }

    return renderWhenNotNil(() => (
      <>
        <FormattedMessage
          {...messages[messageId]}
          values={{
            min: minGroupSize,
            max: maxGroupSize,
          }}
        />{' '}
      </>
    ))(messageId);
  }

  renderGroupDiscountInfo() {
    const { isGroupExperience } = this.props;
    const { discountThreshold, discountPercent } = this.props.experience;
    return renderWhenTrue(() => (
      <FormattedMessage
        {...messages.discount}
        values={{
          percent: discountPercent,
          threshold: discountThreshold,
        }}
      />
    ))(!isGroupExperience && discountThreshold > 0 && discountPercent > 0);
  }

  render() {
    return (
      <Summary>
        {this.renderGroupSizeInfo()}
        {this.renderGroupDiscountInfo()}
      </Summary>
    );
  }
}
